import React, {useEffect, useState} from 'react';
import {Modal} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {set2FAModalState} from "../../redux-store/globalData";
import {getUserInfo, TwoFAModalState} from "../../redux-store/selectors";
import api from "../../api/apiInterceptor";
import {displayNotification} from "../../redux-store/notification";
import {AUTH_FAIL, TWOFA_DISABLED, TWOFA_ENABLED} from "../../constants/Messages";

function TwoFaModal(props) {

    const dispatch = useDispatch()

    const modalStatus = useSelector(TwoFAModalState)
    const userInfo = useSelector(getUserInfo)

    const [qrLink, setQrLink] = useState("")
    const [editData, setEditData] = useState({})
    const [TFAuth, setTFAuth] = useState(false)

    const handleCloseModal = () => {
        dispatch(set2FAModalState(false))
    }

    const fetchQRImage = async () => {
        const result = await api.get("/api/qr")
        setQrLink(result.data)
    }

    const fetchUserInfo = async () => {
        const userData = await api.get(`/api/user/${userInfo?.username ? userInfo.username : userInfo.name}`)
        setEditData(userData.data)
        setTFAuth(userData.data.using2FA)
    }

    useEffect(() => {

        if (modalStatus) {
            fetchUserInfo()
        }

    }, [modalStatus])

    useEffect(() => {
        if (modalStatus && TFAuth) {
            fetchQRImage()
        }
    }, [TFAuth])

    const handleTFAuthChange = (e) => {
        setTFAuth(e.target.checked)
    }

    const handleSave = async () => {
        try{
            await api.put(`/api/user/${userInfo?.username ? userInfo.username : userInfo.name}`, {
                ...editData,
                using2FA: TFAuth
            })
            fetchQRImage();
            if(!TFAuth){
                handleCloseModal()
            }
            dispatch(displayNotification({
                notificationStatus: "success",
                message: TFAuth?TWOFA_ENABLED:TWOFA_DISABLED,
                title: "Аžuriranje korisnika!"
            }))
        }catch (err){
            dispatch(displayNotification({
                notificationStatus: "error",
                message: AUTH_FAIL,
                title: "Prijava na aplikaciju"
            }))
        }
    }

    return (
        <Modal
            show={modalStatus}
            onHide={handleCloseModal}
            backdrop="static"
            keyboard={false}
            size={"sm"}
        >
            <Modal.Header closeButton className={"modal-header-component"}>
                <Modal.Title>{"2FA"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <div className={"row mt-3"}>
                        <div className={"d-flex justify-content-between align-items-center"} >
                            <span className={"form-label t2fa-label"}>Uključi 2FA</span>
                            <input type={"checkbox"} className={"form-check-input"}
                                   name={"using2FA"} checked={TFAuth} onChange={handleTFAuthChange}/>
                        </div>
                        <div className={"d-flex justify-content-end align-items-center"}>
                            <button className={"btn btn-modal-confirm mt-4"} onClick={handleSave}>Sačuvaj</button>
                        </div>
                    </div>
                    <div className={"d-flex justify-content-center flex-column"}>
                        <img src={qrLink}/>
                        {qrLink &&  <span className={"text-muted text-center help-text"}>Skenirate qr kod sa svojom google authenticator aplikacijom</span>}
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default TwoFaModal;
